import { useEffect, useState } from 'react';
import * as S from './ListeningMCQRSingleAnswer.styles';
import { Radio } from '@app/components/common/Radio/Radio';
import { CloseIcon } from '@app/components/common/icons/CloseIcon';
import { CheckSuccessIcon } from '@app/components/common/icons/CheckSuccessIcon';
import { STAGES } from '@app/constants/stages';
import { AudioPlayer } from '@app/components/exam/AudioPlayer';
import useCountdownTimer from '@app/hooks/useCountdownTimer';
import { ScoreInfo } from '@app/components/exam/ScoreInfo';
import { useTranslation } from 'react-i18next';

interface Props {
  audioQuestion: string;
  prepTime: number;
  showAnswer: boolean;
  questionNumber: string;
  initialChoicesString: string;
  correctAnswersString: string;
  isFirstRender: React.MutableRefObject<boolean>;
  allowDrag: boolean;
  onAnswerChange?: (answer: string) => void;
  canStart: boolean;
}
export const ListeningMCQRSingleAnswer: React.FC<Props> = ({
  audioQuestion,
  prepTime,
  showAnswer,
  questionNumber,
  initialChoicesString,
  correctAnswersString,
  allowDrag,
  onAnswerChange,
  canStart,
}) => {
  const { t } = useTranslation();
  const [stage, setStage] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [choices, setChoices] = useState<{ label: string; text: string }[]>([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [scoreLoaded, setScoreLoaded] = useState(false);

  const { seconds, isRunning, start, reset } = useCountdownTimer({
    initialSeconds: prepTime,
    onComplete: () => {
      setStage(STAGES.PLAYING);
      setIsPlaying(true);
    },
  });

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false;
    //   showPermissionModal();
    // } else {
    //   initialize();
    // }
    initialize();
  }, [questionNumber]);

  useEffect(() => {
    onAnswerChange && onAnswerChange(selectedValue || '');
  }, [selectedValue]);

  // const showPermissionModal = () => {
  //   InfoModal({
  //     title: 'Additional permissions',
  //     content: 'Click the OK button to enable record audio.',
  //     onOk: () => {
  //       initialize();
  //     },
  //   });
  // };

  const initialize = () => {
    setSelectedValue(null);
    setStage(null);
    setIsPlaying(false);
    reset();

    if (initialChoicesString) {
      const parsedChoices = JSON.parse(initialChoicesString);
      setChoices(parsedChoices);
    }

    start();
    setStage(STAGES.START);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (stage === STAGES.PLAYING) setStage(STAGES.COMPLETE);
  };

  return (
    <>
      <S.Wrapper>
        {/* {stage === STAGES.START && (
          <p>
            Beginning in <S.TextRed>{seconds}</S.TextRed> seconds
          </p>
        )}
        {stage === STAGES.PLAYING && <p>Status: playing...</p>}
        {stage === STAGES.COMPLETE && <p>Status: Completed</p>} */}
        <S.Box>
          <p className="font-bold mb-2">{t('page.mockTest.audioRecorder')}</p>
          {stage === STAGES.START && (
            <S.TextRed>
              {t('page.mockTest.beginning')} {seconds}
            </S.TextRed>
          )}
          {stage === STAGES.PLAYING && <S.TextRed>{t('page.mockTest.button.playing')}</S.TextRed>}
        </S.Box>
        <AudioPlayer
          audioQuestion={audioQuestion}
          onEnded={handleEnded}
          startPlaying={isPlaying}
          waitingTime={isRunning}
          allowDrag={allowDrag}
          style={{ background: '#F1F1F1', padding: '0.7rem 0.5rem' }}
          canStart={canStart}
        />
      </S.Wrapper>

      <S.ContentQuestion>Which of the following best summarises the main message of this text?</S.ContentQuestion>

      <S.RadioGroupStyle value={selectedValue} onChange={(e) => setSelectedValue(e.target.value)}>
        {choices.map((item) => (
          <div key={item.label} className="flex gap-2 items-center">
            {showAnswer && scoreLoaded && (
              <span
                style={{
                  width: '1em',
                  fontSize: '1rem',
                  color: correctAnswersString === item.label ? 'green' : 'red',
                }}
              >
                {correctAnswersString === item.label ? <CheckSuccessIcon /> : <CloseIcon />}
              </span>
            )}
            <Radio value={item.label}>{item.text}</Radio>
          </div>
        ))}
      </S.RadioGroupStyle>
      {showAnswer && (
        <ScoreInfo answer={selectedValue || ''} questionId={questionNumber} onLoaded={() => setScoreLoaded(true)} />
      )}
    </>
  );
};
